/**
 * <lv-offer> — Wraps the offer form; keeps every [data-offer-total] in sync
 * with the data-total of the checked offer radio.
 */
class LvOffer extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', () => this.update());
    this.update();
  }

  update() {
    const checked = this.querySelector('input[name="id"]:checked');
    if (!checked) return;
    document.querySelectorAll('[data-offer-total]').forEach((el) => {
      el.textContent = checked.dataset.total;
    });
  }
}

if (!customElements.get('lv-offer')) customElements.define('lv-offer', LvOffer);
